import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import CountersCard from '../../ui/CountersCard';
import Breadcrumbs from "../../ui/Breadcrumbs";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import {
    counterExpertiseConstructorQuery,
    counterModuleConstructorQuery,
    counterProgramConstructorQuery,
    counterSkillConstructorQuery
} from "./reducer";

const items = [
    {
        label: "Конструктор КиОП",
        link: "#"
    },
];

const useStyles = makeStyles({
    root: {
        flexGrow: 1,
    },
});

const Index = ({
                   history,
                   counterSkillConstructor,
                   counterModuleConstructor,
                   counterProgramConstructor,
                   counterExpertiseConstructor,
                   counterSkillConstructorQuery,
                   counterModuleConstructorQuery,
                   counterProgramConstructorQuery,
                   counterExpertiseConstructorQuery
               }) => {

    const classes = useStyles();

    const handleClick = (link) => {
        history.push(link);
    };

    useEffect(() => {
        counterSkillConstructorQuery();
    }, [counterSkillConstructorQuery]);

    useEffect(() => {
        counterModuleConstructorQuery();
    }, [counterModuleConstructorQuery]);

    useEffect(() => {
        counterProgramConstructorQuery();
    }, [counterProgramConstructorQuery]);

    useEffect(() => {
        counterExpertiseConstructorQuery();
    }, [counterExpertiseConstructorQuery]);


    return (
        <div>
            <Breadcrumbs items={items}/>
            <div className={classes.root}>
                <Grid container spacing={0} justify="flex-start" alignItems="flex-start">
                    {counterSkillConstructor && <Grid item xs={12} sm={6} md={4} xl={3}>
                        <CountersCard
                            data={counterSkillConstructor}
                            onClick={handleClick}
                            goTo={'/work/app/constructor/competences'}
                        />
                    </Grid>}
                    {counterProgramConstructor && <Grid item xs={12} sm={6} md={4} xl={3}>
                        <CountersCard
                            data={counterProgramConstructor}
                            onClick={handleClick}
                            goTo={'/work/app/constructor/programs'}
                        />
                    </Grid>}
                    {counterModuleConstructor && <Grid item xs={12} sm={6} md={4} xl={3}>
                        <CountersCard
                            data={counterModuleConstructor}
                            onClick={handleClick}
                            goTo={'/work/app/constructor/modules'}
                        />
                    </Grid>}
                    {counterExpertiseConstructor && <Grid item xs={12} sm={6} md={4} xl={3}>
                        <CountersCard
                            data={counterExpertiseConstructor}
                            onClick={handleClick}
                            goTo={'/work/app/constructor/expertise'}
                        />
                    </Grid>}
                </Grid>
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    counterSkillConstructor: state.constructorIndex.counterSkillConstructor,
    counterModuleConstructor: state.constructorIndex.counterModuleConstructor,
    counterProgramConstructor: state.constructorIndex.counterProgramConstructor,
    counterExpertiseConstructor: state.constructorIndex.counterExpertiseConstructor
});

const mapDispatchToProps = dispatch => ({
    counterSkillConstructorQuery: () => dispatch(counterSkillConstructorQuery()),
    counterModuleConstructorQuery: () => dispatch(counterModuleConstructorQuery()),
    counterProgramConstructorQuery: () => dispatch(counterProgramConstructorQuery()),
    counterExpertiseConstructorQuery: () => dispatch(counterExpertiseConstructorQuery())
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Index));
